import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import { formatTime } from '@/checkout-instore-legacy/utils/DateUtils'
import { getOrdersDate } from '@/checkout-instore-legacy/order/utils'

class OrderCard extends Component {
  render() {
    const { order, intl } = this.props

    const date = getOrdersDate(intl, order.creationDate)
    const time = formatTime(new Date(order.creationDate))

    return (
      <div
        className="flex flex-row ba b--muted-4 w-100 br3 mb3 c-on-base pointer"
        style={{ height: '150px' }}
        onClick={this.props.onClick}
      >
        <div className="flex flex-column items-center justify-center ph5">
          <span>{date} </span>
          <span>
            <FormattedMessage id="orders.card.time" values={{ time }} />
          </span>
        </div>
        <div className="flex pv5">
          <div className="flex flex-column bl b--muted-4 justify-between ph5">
            <div>{`#${order.orderId}`} </div>
            <div
              className="flex flex-column justify-between"
              style={{ height: '40px' }}
            >
              <span className="c-muted-2 t-small">
                <FormattedMessage id="orders.client" />
              </span>
              <span>{order.clientName} </span>
            </div>
            <div
              className="flex flex-column justify-between"
              style={{ height: '40px' }}
            >
              <span className="c-muted-2 t-small">
                <FormattedMessage id="orders.vendor" />
              </span>
              <span>{order.vendorName} </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

OrderCard.propTypes = {
  order: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default injectIntl(OrderCard)
